import { useEffect, useState } from 'react';
import React from 'react';

import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { Select, Input, message, Space, Button, Divider, Spin } from 'antd';

import sessionManager, { eVariableType } from '../../SessionManager';
import api from '../../api';
import stringres from '../../translations/stringres';

export default function CmbGenerico({
    value,
    placeholder,
    onChange,
    queryurl,
    insertupdateurl,
    deleteurl,
    campoid,
    campoidSocieta,
    campoDescrizione,
}) {
    const [data, setData] = useState(null);
    const [descrizione, setDescrizione] = useState('');
    const [selected, setSelected] = useState(null);
    const [isLoading, setisLoading] = useState(false);

    useEffect(() => {
        fetchData();
    }, []);

    async function fetchData() {
        try {
            setisLoading(true);
            const result = await api.get(
                queryurl + '?' + campoidSocieta + '=' + sessionManager.get(eVariableType.IDSocieta)
            );

            if (result != null && result.data) {
                setData(result.data);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setisLoading(false);
        }
    }

    async function addItem() {
        try {
            if (descrizione.length === 0) return;

            const sc = campoidSocieta;
            const dsc = campoDescrizione;
            const request = {
                [sc]: sessionManager.get(eVariableType.IDSocieta),
                [dsc]: descrizione,
            };
            console.log('campo', campoDescrizione);
            console.log(request);
            const result = await api.post(insertupdateurl, request);

            if (result != null && result.data) {
                fetchData();

                setDescrizione(null);
                setSelected(null);

                message.success(stringres.t('successo'));
            }
        } catch (error) {
            message.error(error.response.data.message, 5);
        }
    }

    async function removeItem() {
        try {
            console.log(
                deleteurl +
                    '?' +
                    campoidSocieta +
                    '=' +
                    sessionManager.get(eVariableType.IDSocieta) +
                    '&' +
                    campoid +
                    '=' +
                    selected
            );
            const result = await api.delete(
                deleteurl +
                    '?' +
                    campoidSocieta +
                    '=' +
                    sessionManager.get(eVariableType.IDSocieta) +
                    '&' +
                    campoid +
                    '=' +
                    selected
            );

            if (result != null && result.data) {
                fetchData();

                message.success(stringres.t('successo'));
            }
        } catch (error) {
            message.error(stringres.t('impossibileeliminare') + error.response.data.message, 5);
        }
    }

    const handleSelectChange = (value) => {
        //        setDescrizione(value);
        setSelected(value);
        onChange(value);
    };

    const opt = data?.map((item) => ({
        key: campoid,
        value: campoid,
        label: campoDescrizione,
    }));

    const onChangeInput = (event) => {
        setDescrizione(event.target.value);
    };

    return (
        <Spin spinning={isLoading}>
            <Select
                value={value}
                placeholder={placeholder}
                onChange={handleSelectChange}
                dropdownRender={(menu) => (
                    <>
                        {menu}
                        <Divider style={{ margin: '8px 0' }} />
                        <Space style={{ padding: '0 8px 4px' }}>
                            <Input
                                placeholder={stringres.t('inseriscinuovoelemento')}
                                value={descrizione}
                                onChange={onChangeInput}
                            />
                            <Button type="text" icon={<PlusOutlined />} onClick={addItem}>
                                {stringres.t('nuovo')}
                            </Button>
                        </Space>
                        <Divider style={{ margin: '8px 0' }} />
                        <Button
                            style={{ padding: '0 8px 4px', width: '100%' }}
                            icon={<DeleteOutlined />}
                            onClick={removeItem}
                        >
                            {stringres.t('eliminaelementoselezionato')}
                        </Button>
                    </>
                )}
                options={data?.map((item) => ({
                    label: item[campoDescrizione],
                    value: item[campoid],
                    key: item[campoid],
                }))}
            ></Select>
        </Spin>
    );
}
